import { ChartFactory, CommonChartUtil, EmptyColumnChartCustomAttributes } from '@ddt-web/chart';
import { TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

export class InsightsChartHelper {
	constructor(public data: TabData, public selectedPortfolioIndex: number) { }

	/**
	 * initCategories: initializes the category based data for the y-axis labels.
	 */
	public initCategories(): Array<any> {
		const categories: Array<any> = this.data.tableData[0].headersX.filter(header => {
			if (!header.attribute || header.attribute.ignoreInChart !== true) {
				return header;
			}
		});
		return categories;
	}

	/**
	 * initHeaderInfo: initializes the header info for a given section.
	 */
	public initHeaderInfo(): string {
		return this.data?.config?.title?.label.toString();
	}

	/**
	 * initSubHeaderInfo: initializes the sub-header info for the given category.
	 */
	public initSubHeaderInfo(categories: Array<any>): any {
		let subHeaderText: string;
		let showSubHeaderContent: boolean;
		let subHeaderValue: string;
		if (categories.length > 0) {
			const category = this.data.tableData[0].headersX.find(category => category.attribute?.includedAsSubHeader);
			const index = this.data.tableData[0].headersX.findIndex(category => category.attribute?.includedAsSubHeader);
			if (category) {
				subHeaderText = get(category, 'attribute.hideLabel', false) ? '' : category.formattedValue;
				showSubHeaderContent = category.attribute.includedAsSubHeader;
				const cell = get(this.data, `tableData[0].cells[${this.selectedPortfolioIndex}][${index}]`);
				subHeaderValue = get(cell, 'formattedValue') && get(cell, 'rawValue') ? get(cell, 'formattedValue') : '0.00%';
			}
		}
		return { subHeaderText, subHeaderValue, showSubHeaderContent };
	}

	public initChartAttributes(): EmptyColumnChartCustomAttributes {
		let emptyColumnChartAttributes: EmptyColumnChartCustomAttributes;
		const chartData = ChartFactory.getStackedData(this.data, this.selectedPortfolioIndex);
		if (chartData.series) {
			emptyColumnChartAttributes = {
				tickPositions: CommonChartUtil.recalculateAxisFromData(chartData.series)
			};
		}
		return emptyColumnChartAttributes;
	}

	public isDisplaying(category): boolean {
		return category.formattedValue !== 'Other' || (category.formattedValue === 'Other' && this.isUnknownHasValue());
	}

	private isUnknownHasValue(): boolean {
		const headersX = get(this.data, 'tableData[0].headersX');
		if (!headersX) { return false; }
		const unknownCategoryIndex = this.data.tableData[0].headersX.findIndex(header => header.formattedValue === 'Other');
		if (unknownCategoryIndex === -1) { return false; }
		return !!this.data.tableData[0].cells[this.selectedPortfolioIndex][unknownCategoryIndex].rawValue;
	}
}
